import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getTechnicalReportById } from "../../actions/VehicleReplacementsActions";
import { useParams } from "react-router-dom";
import moment from "moment/moment";
import { getBatchById } from "../../actions/BatchActions";
import { getJobCardById } from "../../actions/JobCardActions";
import { ThreeDots } from "react-loader-spinner";
import { getEstimateById } from "../../actions/EstimateActions";
import { printStyles } from "../../constants/customStyles";
import SignatureCanvas from 'react-signature-canvas'

function InvoiceEstimate() {
    const dispatch = useDispatch();
    const params = useParams();

    const [editableEstimate, setEditableEstimate] = useState({});
    const [modalIsOpen, setModalIsOpen] = useState(false);

    useEffect(() => {
        dispatch(getEstimateById(params.estimate_id))
    }, [params.id])

    const estimate = useSelector(state => state?.estimate?.estimate);
    const loading = useSelector(state => state?.loading?.addEditLoading);
    const estimateYear = estimate?.created_at ? new Date(estimate.created_at).getYear() % 100 : 0;
    const estimateMonth = estimate?.created_at ? new Date(estimate.created_at).getMonth() + 1 : 0;
    const formattedestimateId = estimate?.estimate_id ? String(estimate.estimate_id).padStart(6, '0') : 0;

    useEffect(() => {
        document.title = "ATA-" + estimateYear + estimateMonth + '-' + formattedestimateId + "ESTIMATE INV";
        loadSignatureFromBase64(estimate?.vehicle_graph?.vehicle_graph);
        setEditableEstimate(prevState => ({
            ...prevState,
            ...estimate,
            show_spare_parts: true,
            show_repair_parts: true
        }));
    }, [estimate]);
    // const handlePrint = () => {
    //     if (document.readyState === 'complete') {
    //         setTimeout(() => {
    //             window.print();
    //         }, 1500);
    //     } else {
    //         window.addEventListener('load', () => {
    //             setTimeout(() => {
    //                 window.print();
    //             }, 1500);
    //         });
    //     }
    // };

    // useEffect(() => {
    //     if (jobCard && Object.keys(jobCard).length > 0) {
    //         handlePrint();
    //     }
    // }, [jobCard]);

    const repairDetails = estimate.detail && estimate.detail
        .filter(detail => detail.product_type === 'service');

    const repairTotal = repairDetails && repairDetails.reduce((total, detail) => total + parseFloat(detail.estimate_total_amount), 0);

    const spareDetails = estimate.detail && estimate.detail
        .filter(detail => detail.product_type === 'goods');

    const spareTotal = spareDetails && spareDetails.reduce((total, detail) => total + parseFloat(detail.estimate_total_amount), 0);
    const spareEstimateTotal = spareDetails && spareDetails.reduce((total, detail) => total + parseFloat(detail.estimate_total_amount), 0);

    const signatureRef = useRef(null);

    const clearCanvas = () => {
        signatureRef.current.clear(); // Clear the canvas
    };

    const loadSignatureFromBase64 = (base64String) => {
        if (signatureRef.current && base64String) {
            // Clear the current canvas before loading the new data
            signatureRef.current.clear();

            // Create an image to load base64 and adjust scaling
            const img = new Image();
            img.src = base64String;
            img.onload = () => {
                const canvas = signatureRef.current.getCanvas();
                const ctx = canvas.getContext('2d');
                ctx.clearRect(0, 0, canvas.width, canvas.height); // Clear the canvas

                // Ensure the canvas size matches original
                canvas.width = 230;
                canvas.height = 160;

                // Draw the base64 image onto the canvas, adjusting for any offset
                ctx.drawImage(img, 0, 0, 230, 160);
            };
        }
    };
    const handleKeyDown = (event) => {
        if (event.key === 'F9') {
            setModalIsOpen(true);
        } else if (event.key === 'Escape') {
            setModalIsOpen(false);
        }
    };

    useEffect(() => {
        window.addEventListener('keydown', handleKeyDown);
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, []);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setEditableEstimate(prevState => {
            const newState = { ...prevState };
            const keys = name.split('.');
            let current = newState;
            for (let i = 0; i < keys.length - 1; i++) {
                if (!current[keys[i]]) {
                    current[keys[i]] = {};
                }
                current = current[keys[i]];
            }
            current[keys[keys.length - 1]] = value;
            return { ...newState }; // Ensure a new object is returned
        });
    };

    return (
        <React.Fragment>
            <body className="bg-white w-full h-screen overflow-visible">
                <div className="intro-y w-full h-full bg-white container-fluid pt-5 position-relative">
                    <div className="text-center text-sm-start">
                        <div className="">
                            <img className="print-header" src="/images/invoice-head.jpg" width={'100%'} height={60} alt="" />
                            <div className="text-center mt-5 text-decoration-underline fw-semibold fs-2xl mt-10">ESTIMATE</div>
                        </div>
                        {
                            loading ?
                                <ThreeDots
                                    height="80"
                                    width="80"
                                    radius="9"
                                    color="#2d3748"
                                    ariaLabel="three-dots-loading"
                                    wrapperStyle={{ justifyContent: 'center', alignItems: 'center', height: '100%' }}
                                    wrapperClassName=""
                                    visible={loading}
                                /> :
                                <span>
                                    <div className="row mt-3 p-3">
                                        <div className="col-md-6">
                                            <div className="row">
                                                <div className="col-md-4 pe-0">
                                                    <div className="border border-gray-500 p-1 bg-gray-300 h-full">
                                                        <h3 className="fw-bold">Estimate No : </h3>
                                                    </div>
                                                </div>
                                                <div className="col-md-4 px-0">
                                                    <div className="p-1 border border-gray-500">
                                                        <h3 className="text-capitalize">{estimate?.estimate_id ?? '-'}</h3>
                                                    </div>
                                                </div>
                                                <div className="col-md-4 ps-0">
                                                    <div className="border border-gray-500 p-1 bg-gray-300 h-full text-end">
                                                        <h3 className="fw-bold text-end">: رقم التقدير</h3>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="row">
                                                <div className="col-md-4 pe-0">
                                                    <div className="border border-gray-500 p-1 bg-gray-300 h-full">
                                                        <h3 className="fw-bold">Estimate Date : </h3>
                                                    </div>
                                                </div>
                                                <div className="col-md-4 px-0">
                                                    <div className="p-1 border border-gray-500">
                                                        <h3 className="text-capitalize">{moment(estimate?.estimate_date).format('YYYY-MM-DD') ?? '-'}</h3>
                                                    </div>
                                                </div>
                                                <div className="col-md-4 ps-0">
                                                    <div className="border border-gray-500 p-1 bg-gray-300 h-full text-end">
                                                        <h3 className="fw-bold text-end">: تاريخ التقدير</h3>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-12 mt-2">
                                            <div className="row">
                                                <div className="col-md-4 pe-0">
                                                    <div className="border border-gray-500 p-1 bg-gray-300 h-full">
                                                        <h3 className="fw-bold">Mr / Mrs / Miss : </h3>
                                                    </div>
                                                </div>
                                                <div className="col-md-4 px-0">
                                                    <div className="p-1 border border-gray-500 text-center">
                                                        <h3 className="text-capitalize">{estimate?.customer?.name ?? '-'}</h3>
                                                    </div>
                                                </div>
                                                <div className="col-md-4 ps-0">
                                                    <div className="border border-gray-500 p-1 bg-gray-300 h-full text-end">
                                                        <h3 className="fw-bold">: السيد / السيدة / الآنسة</h3>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-12 mt-2">
                                            <div className="row">
                                                <div className="col-md-4 pe-0">
                                                    <div className="border border-gray-500 p-1 bg-gray-300 h-full">
                                                        <h3 className="fw-bold">Type Of Vehicle : </h3>
                                                    </div>
                                                </div>
                                                <div className="col-md-4 px-0">
                                                    <div className="p-1 border border-gray-500 text-center">
                                                        <h3 className="text-capitalize">{estimate?.vehicle?.vehicle_type?.name + ' - ' + estimate?.vehicle?.vehicle_make?.name ?? '-'}</h3>
                                                    </div>
                                                </div>
                                                <div className="col-md-4 ps-0">
                                                    <div className="border border-gray-500 p-1 bg-gray-300 h-full text-end">
                                                        <h3 className="fw-bold">: نوع المركبة</h3>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-12 mt-2">
                                            <div className="row">
                                                <div className="col-md-4 pe-0">
                                                    <div className="border border-gray-500 p-1 bg-gray-300 h-full">
                                                        <h3 className="fw-bold">Insurance Company : </h3>
                                                    </div>
                                                </div>
                                                <div className="col-md-4 px-0">
                                                    <div className="p-1 border border-gray-500 text-center">
                                                        <h3 className="text-capitalize">{estimate?.insurance_company?.name ?? '-'}</h3>
                                                    </div>
                                                </div>
                                                <div className="col-md-4 ps-0">
                                                    <div className="border border-gray-500 p-1 bg-gray-300 h-full text-end">
                                                        <h3 className="fw-bold">: شركة التأمين</h3>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6 mt-2">
                                            <div className="row">
                                                <div className="col-md-4 pe-0">
                                                    <div className="border border-gray-500 p-1 bg-gray-300 h-full">
                                                        <h3 className="fw-bold">Registration : </h3>
                                                    </div>
                                                </div>
                                                <div className="col-md-4 px-0">
                                                    <div className="p-1 border border-gray-500">
                                                        <h3 className="text-capitalize">{estimate?.vehicle?.plate_number ?? '-'}</h3>
                                                    </div>
                                                </div>
                                                <div className="col-md-4 ps-0">
                                                    <div className="border border-gray-500 p-1 bg-gray-300 h-full text-end">
                                                        <h3 className="fw-bold text-end">: التسجيل</h3>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6 mt-2">
                                            <div className="row">
                                                <div className="col-md-4 pe-0">
                                                    <div className="border border-gray-500 p-1 bg-gray-300 h-full">
                                                        <h3 className="fw-bold">Model : </h3>
                                                    </div>
                                                </div>
                                                <div className="col-md-4 px-0">
                                                    <div className="p-1 border border-gray-500">
                                                        <h3 className="text-capitalize">{estimate?.vehicle?.vehicle_model?.name ?? '-'}</h3>
                                                    </div>
                                                </div>
                                                <div className="col-md-4 ps-0">
                                                    <div className="border border-gray-500 p-1 bg-gray-300 h-full text-end">
                                                        <h3 className="fw-bold text-end">: نموذج</h3>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-12 mt-2">
                                            <div className="row">
                                                <div className="col-md-4 pe-0">
                                                    <div className="border border-gray-500 p-1 bg-gray-300 h-full">
                                                        <h3 className="fw-bold">Accident Side : </h3>
                                                    </div>
                                                </div>
                                                <div className="col-md-4 px-0">
                                                    <div className="p-1 border border-gray-500 text-center">
                                                        <h3 className="text-capitalize">{estimate?.accident_side ?? '-'}</h3>
                                                    </div>
                                                </div>
                                                <div className="col-md-4 ps-0">
                                                    <div className="border border-gray-500 p-1 bg-gray-300 h-full text-end">
                                                        <h3 className="fw-bold">: جانب الحوادث</h3>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-12 mt-2">
                                            <div className="row">
                                                <div className="col-md-4 pe-0">
                                                    <div className="border border-gray-500 p-1 bg-gray-300 h-full">
                                                        <h3 className="fw-bold">Repairing Time : </h3>
                                                    </div>
                                                </div>
                                                <div className="col-md-4 px-0">
                                                    <div className="p-1 border border-gray-500 text-center">
                                                        <h3 className="text-capitalize">{estimate?.repair_time ?? '-'}</h3>
                                                    </div>
                                                </div>
                                                <div className="col-md-4 ps-0">
                                                    <div className="border border-gray-500 p-1 bg-gray-300 h-full text-end">
                                                        <h3 className="fw-bold">: إصلاح الوقت</h3>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-12 mt-2">
                                            <div className="row">
                                                <div className="col-md-4 pe-0">
                                                    <div className="border border-gray-500 p-1 bg-gray-300 h-full">
                                                        <h3 className="fw-bold">Total DHS : </h3>
                                                    </div>
                                                </div>
                                                {
                                                    estimate?.lump_sum == "1" ? <>
                                                        <div className="col-md-4 px-0">
                                                            <div className="p-1 border border-gray-500 text-center">
                                                                <h3 className="text-capitalize">{estimate?.lump_sum_amount ?? '-'}</h3>
                                                            </div>
                                                        </div>
                                                    </> :
                                                        <>
                                                            <div className="col-md-4 px-0">
                                                                <div className="p-1 border border-gray-500 text-center">
                                                                    <h3 className="text-capitalize">{estimate?.total_amount ?? '-'}</h3>
                                                                </div>
                                                            </div>
                                                        </>
                                                }
                                                <div className="col-md-4 ps-0">
                                                    <div className="border border-gray-500 p-1 bg-gray-300 h-full text-end">
                                                        <h3 className="fw-bold">: مجموع الدرهم</h3>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-8 mt-3">
                                            <div className="row">
                                                {
                                                    estimate?.lump_sum == "1" ? <>
                                                        {
                                                            estimate?.detail && Object.keys(estimate?.detail).length > 0 &&
                                                            editableEstimate?.show_repair_parts && estimate?.detail.filter(detail => detail.product_type === 'service')
                                                                .length > 0 && (
                                                                <div className="col-md-4 mt-3">
                                                                    <table class="table table-bordered border border-gray-500">
                                                                        <thead>
                                                                            <tr>
                                                                                <th className="fw-bold bg-gray-300 p-1">Repairs</th>
                                                                                {/* <th className="fw-bold bg-gray-300 p-1">Value</th> */}
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {
                                                                                estimate?.detail && Object.keys(estimate?.detail).length > 0 &&
                                                                                estimate?.detail
                                                                                    .filter(detail => detail.product_type === 'service')
                                                                                    .map((detail, index) => {
                                                                                        return (
                                                                                            <tr>
                                                                                                <td className="fs-xs p-1">{detail?.product_name}</td>
                                                                                                {/* <td className="fs-xs p-1">{parseFloat(detail?.total_amount).toFixed(2)}</td> */}
                                                                                            </tr>
                                                                                        )
                                                                                    })
                                                                            }
                                                                        </tbody>
                                                                        {/* <tfoot>
                                                                <tr>
                                                                    <td className="fs-xs p-1">Total Repair</td>
                                                                    <td className="fs-xs p-1">{repairTotal}</td>
                                                                </tr>
                                                            </tfoot> */}
                                                                    </table>
                                                                </div>
                                                            )
                                                        }
                                                        {
                                                            estimate?.detail && Object.keys(estimate?.detail).length > 0 &&
                                                            editableEstimate?.show_spare_parts && estimate?.detail.filter(detail => detail.product_type === 'goods').length > 0 && (
                                                                [0, 1].map((partIndex) => (
                                                                    <div className="col-md-4" key={partIndex}>
                                                                        <table className="table table-bordered border border-gray-500">
                                                                            <thead>
                                                                                <tr>
                                                                                    <th className="fw-bold bg-gray-300 p-1">Spares</th>
                                                                                </tr>
                                                                            </thead>
                                                                            <tbody>
                                                                                {
                                                                                    estimate?.detail
                                                                                        .filter(detail => detail.product_type === 'goods')
                                                                                        .slice(
                                                                                            partIndex * Math.ceil(estimate?.detail.filter(detail => detail.product_type === 'goods').length / 2),
                                                                                            (partIndex + 1) * Math.ceil(estimate?.detail.filter(detail => detail.product_type === 'goods').length / 2)
                                                                                        )
                                                                                        .map((detail, index) => (
                                                                                            <tr key={index}>
                                                                                                <td className="fs-xs p-1">{detail?.product_name}</td>
                                                                                            </tr>
                                                                                        ))
                                                                                }
                                                                            </tbody>
                                                                        </table>
                                                                    </div>
                                                                ))


                                                            )
                                                        }

                                                    </> :
                                                        <>
                                                            {
                                                                estimate?.detail && Object.keys(estimate?.detail).length > 0 &&
                                                                editableEstimate?.show_repair_parts && estimate?.detail.filter(detail => detail.product_type === 'service')
                                                                    .length > 0 && (
                                                                    <div className="col-md-4 mt-3">
                                                                        <table class="table table-bordered border border-gray-500">
                                                                            <thead>
                                                                                <tr>
                                                                                    <th className="fw-bold bg-gray-300 p-1">Repairs</th>
                                                                                    <th className="fw-bold bg-gray-300 p-1">Value</th>
                                                                                </tr>
                                                                            </thead>
                                                                            <tbody>
                                                                                {
                                                                                    estimate?.detail && Object.keys(estimate?.detail).length > 0 &&
                                                                                    estimate?.detail
                                                                                        .filter(detail => detail.product_type === 'service')
                                                                                        .map((detail, index) => {
                                                                                            return (
                                                                                                <tr>
                                                                                                    <td className="fs-xs p-1">{detail?.product_name}</td>
                                                                                                    <td className="fs-xs p-1">{parseFloat(detail?.estimate_total_amount).toFixed(2)}</td>
                                                                                                </tr>
                                                                                            )
                                                                                        })
                                                                                }
                                                                            </tbody>
                                                                            <tfoot>
                                                                                <tr>
                                                                                    <td className="fs-xs p-1">Total Repair</td>
                                                                                    <td className="fs-xs p-1">{repairTotal}</td>
                                                                                </tr>
                                                                            </tfoot>
                                                                        </table>
                                                                    </div>
                                                                )
                                                            }
                                                            {
                                                                estimate?.detail && Object.keys(estimate?.detail).length > 0 &&
                                                                editableEstimate?.show_spare_parts && estimate?.detail.filter(detail => detail.product_type === 'goods')
                                                                    .length > 0 && (
                                                                    <div className="col-md-4 mt-3">
                                                                        <table class="table table-bordered border border-gray-500">
                                                                            <thead>
                                                                                <tr>
                                                                                    <th className="fw-bold bg-gray-300 p-1">Spares</th>
                                                                                    <th className="fw-bold bg-gray-300 p-1">Value</th>
                                                                                </tr>
                                                                            </thead>
                                                                            <tbody>
                                                                                {
                                                                                    estimate?.detail && Object.keys(estimate?.detail).length > 0 &&
                                                                                    estimate?.detail
                                                                                        .filter(detail => detail.product_type === 'goods')
                                                                                        .map((detail, index) => {
                                                                                            return (
                                                                                                <tr>
                                                                                                    <td className="fs-xs p-1">{detail?.product_name}</td>
                                                                                                    <td className="fs-xs p-1">{parseFloat(detail?.estimate_total_amount).toFixed(2)}</td>
                                                                                                </tr>
                                                                                            )
                                                                                        })
                                                                                }
                                                                            </tbody>
                                                                            <tfoot>
                                                                                <tr>
                                                                                    <td className="fs-xs p-1">Total Spare</td>
                                                                                    <td className="fs-xs p-1">{spareTotal}</td>
                                                                                </tr>
                                                                            </tfoot>
                                                                        </table>
                                                                    </div>
                                                                )
                                                            }
                                                        </>
                                                }
                                            </div>
                                        </div>
                                        < div className="col-md-4 d-flex justify-content-end mt-3">
                                            <div className="border border-gray-300 rounded-2 canvas-bg" style={{ width: 230, height: 160 }}>
                                                <SignatureCanvas
                                                    penColor='transparent'
                                                    ref={(ref) => (signatureRef.current = ref)}
                                                    onKeyPress={clearCanvas}
                                                    canvasProps={{ width: 230, height: 160, className: 'signatureCanvas' }}
                                                />
                                            </div>
                                        </div>
                                        < div className="col-md-12 mt-3">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <p>
                                                        Although every care has been taken in compiling, this
                                                        estimate it is possible that when dismantling, further damage
                                                        may be found. if so the cost will be increased accordingly.
                                                        <br />
                                                        This estimate is valid for 15 days only from the date
                                                        mentioned.
                                                    </p>
                                                </div>
                                                <div className="col-md-6">
                                                    <p className="text-end">
                                                        على الرغم من أنه قد تم اتخاذ كل العناية في التجميع، إلا أن هذا
                                                        تقدير أنه من الممكن أنه عند التفكيك، مزيد من الضرر
                                                        ويمكن الاطلاع على. إذا كان الأمر كذلك سيتم زيادة التكلفة وفقا لذلك <br />
                                                        وهذا التقدير صالح لمدة 15 يومًا فقط من تاريخه
                                                        مذكور.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6 mt-3"></div>
                                        <div className="row">
                                            <div className="col-md-3">
                                                <div className="row">
                                                    <div className="col-md-5 pe-0">
                                                        <div className="border border-gray-500 p-1 bg-gray-300 h-full">
                                                            <h3 className="fw-bold fs-xs">Date & Time In : </h3>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-7 ps-0">
                                                        <div className="p-1 border border-gray-500">
                                                            <h3 className="text-capitalize fs-xs">{estimate?.estimate_date ?? '-'}</h3>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-3 ps-0">
                                                <div className="row">
                                                    <div className="col-md-5 pe-0">
                                                        <div className="border border-gray-500 p-1 bg-gray-300 h-full">
                                                            <h3 className="fw-bold fs-xs">In Mobile : </h3>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-7 ps-0">
                                                        <div className="p-1 border border-gray-500">
                                                            <h3 className="text-capitalize fs-xs">{estimate?.customer?.mobile ?? '-'}</h3>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-3 ps-0">
                                                <div className="row">
                                                    <div className="col-md-5 pe-0">
                                                        <div className="border border-gray-500 p-1 bg-gray-300 h-full">
                                                            <h3 className="fw-bold fs-xs">KM In : </h3>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-7 ps-0">
                                                        <div className="p-1 border border-gray-500">
                                                            <h3 className="text-capitalize fs-xs">{estimate?.milage ?? '-'}</h3>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-3 ps-0">
                                                <div className="row">
                                                    <div className="col-md-5 pe-0">
                                                        <div className="border border-gray-500 p-1 bg-gray-300 h-full">
                                                            <h3 className="fw-bold fs-xs">Advisor : </h3>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-7 ps-0">
                                                        <div className="p-1 border border-gray-500 w-full">
                                                            {/* <h3 className="text-capitalize fs-xs">{jobCard?.estimate?.vehicle?.vehicle_model?.name ?? '-'}</h3> */}
                                                            <h3 className="text-capitalize fs-xs">{estimate?.created_by_name ?? '-'}</h3>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-12 mt-5" >
                                            <div className="border border-gray-500 p-1 bg-gray-300 h-full">
                                                <h3 className="fw-bold">Signatures : </h3>
                                            </div>
                                        </div>
                                    </div>
                                </span>
                        }
                    </div>
                    <div className="position-absolute bottom-0 w-full">
                        <img className="print-footer" src="/images/invoice-foot.jpg" width={'100%'} height={60} alt="" />
                    </div>
                </div>
            </body >

            <div className={`modal fade  ${modalIsOpen ? 'show' : ''}`} tabIndex="-1" role="dialog" style={{ display: modalIsOpen ? 'block' : 'none', border: '1px solid black' }}>
                <div className="modal-dialog modal-xl" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Edit Estimate</h5>
                        </div>
                        <div className="modal-body">
                            <form>
                                <div className="row">

                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label>Customer Name:</label>
                                            <input type="text" className="form-control" name="customer.name" value={editableEstimate?.customer?.name ?? ''} onChange={handleInputChange} />
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label>Customer Name:</label>
                                            <input type="text" className="form-control" name="customer.mobile" value={editableEstimate?.customer?.mobile ?? ''} onChange={handleInputChange} />
                                        </div>
                                    </div>

                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label>Registration Expiry:</label>
                                            <input type="date" className="form-control" name="vehicle.registration_expiry" value={editableEstimate?.vehicle?.registration_expiry ? moment(editableEstimate.vehicle.registration_expiry).format('YYYY-MM-DD') : ''} onChange={handleInputChange} />
                                        </div>
                                    </div>

                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label>Insurance Company:</label>
                                            <input type="text" className="form-control" name="insurance_company.name" value={editableEstimate?.insurance_company?.name ?? ''} onChange={handleInputChange} />
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label>Model:</label>
                                            <input type="text" className="form-control" name="vehicle.vehicle_model.name" value={editableEstimate?.vehicle?.vehicle_model?.name ?? ''} onChange={handleInputChange} />
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label>Plate Number:</label>
                                            <input type="text" className="form-control" name="vehicle.plate_number" value={editableEstimate?.vehicle?.plate_number ?? ''} onChange={handleInputChange} />
                                        </div>
                                    </div>

                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label>Vehicle Code:</label>
                                            <input type="text" className="form-control" name="vehicle.vehicle_code.name" value={editableEstimate?.vehicle?.vehicle_code?.name ?? ''} onChange={handleInputChange} />
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label>State:</label>
                                            <input type="text" className="form-control" name="vehicle.state.name" value={editableEstimate?.vehicle?.state?.name ?? ''} onChange={handleInputChange} />
                                        </div>
                                    </div>

                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label>Type:</label>
                                            <input type="text" className="form-control" name="type_id" value={editableEstimate?.type_id === 1 ? 'Private' :
                                                editableEstimate?.type_id === 2 ? 'Insurance' :
                                                    editableEstimate?.type_id === 3 ? 'N/A' : ''} onChange={handleInputChange} />
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label>Chasis No:</label>
                                            <input type="text" className="form-control" name="vehicle.chasis_no" value={editableEstimate?.vehicle?.chasis_no ?? ''} onChange={handleInputChange} />
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label>Vehicle Type:</label>
                                            <input type="text" className="form-control" name="vehicle.vehicle_type.name" value={editableEstimate?.vehicle?.vehicle_type?.name ?? ''} onChange={handleInputChange} />
                                        </div>
                                    </div>

                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label>Vehicle Make:</label>
                                            <input type="text" className="form-control" name="vehicle.vehicle_make.name" value={editableEstimate?.vehicle?.vehicle_make?.name ?? ''} onChange={handleInputChange} />
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label>Color:</label>
                                            <input type="text" className="form-control" name="vehicle.color.name" value={editableEstimate?.vehicle?.color?.name ?? ''} onChange={handleInputChange} />
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label>Show Repair Parts:</label>
                                            <input type="checkbox" className="" name="show_repair_parts" checked={editableEstimate?.show_repair_parts ?? false} value={editableEstimate?.show_repair_parts} onChange={(e) => {
                                                handleInputChange({ target: { name: 'show_repair_parts', value: e.target.checked } });
                                            }} />
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label>Show Spare Parts:</label>
                                            <input type="checkbox" className="" name="show_spare_parts" checked={editableEstimate?.show_spare_parts ?? false} value={editableEstimate?.show_spare_parts} onChange={(e) => {
                                                handleInputChange({ target: { name: 'show_spare_parts', value: e.target.checked } });
                                            }} />
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" onClick={() => setModalIsOpen(false)}>Close</button>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment >
    )
}

export default InvoiceEstimate;